module.exports = __webpack_public_path__ + "fonts/effect-deadly-presence-9785db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-deadly-presence.svg
// module id = 735
// module chunks = 0